{
  "id": 50,
  "location": "paris",
  "difficulty": "hard",
  "moves": 33,
  "kinds": 6,
  "goals": [
    { "type": "mud" },
    { "type": "collect", "kind": "croissant", "count": 48 },
    { "type": "collect", "kind": "latte", "count": 48 }
  ],
  "stars": [6430, 7550],
  "board": [
    ". . . . . . . .",
    ". . . . . . . .",
    "x x x x x x x x",
    "X X X X X X X X",
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . . . . . ."
  ],
  "calibration": { "runs": 1000, "winRate": 0.448, "movesLeft": 3.8, "closeLosses": 0.118, "target": 0.42 }
}
